<mat-sidenav-container style="height: 100vh;">
    <!-- <mat-sidenav #sidenav class="mat-sidenav-style">
      <mat-nav-list>
        <app-side-enovsky *ngIf="currentRoute == ''" [userInfos]="userInfos"></app-side-enovsky>
        <app-side-virtualcampus *ngIf="currentRoute == 'virtualcampus'" [userInfos]="userInfos"></app-side-virtualcampus>
        <app-side-virtualclass *ngIf="currentRoute == 'virtualclass'" [userInfos]="userInfos"></app-side-virtualclass>
      </mat-nav-list>
    </mat-sidenav> -->
    <mat-sidenav-content style="overflow: hidden;">
        <mat-toolbar class="mat-elevation-z2 toolbar-style">
            <div style="height: 30px; width: 50px; justify-content: center;"><h3 style="color: white;">ePanel</h3></div>
            <div class="spacer"></div>
            <div class="spacer"></div>
        <!-- <mat-icon style="cursor: pointer;" aria-hidden="false" fontIcon="menu" title="Mop" (click)="sidenav.open()"></mat-icon>
        
        <a [routerLink]="'virtualcampus'" [ngClass]="{'active-page' : currentRoute == 'virtualcampus'}" class="toolbar-menu" (click)="shareUserData()">University (VCA)</a>
        <a [routerLink]="'virtualclass'" [ngClass]="{'active-page' : currentRoute == 'virtualclass'}" class="toolbar-menu" (click)="shareUserData()">Secondary (VCL)</a> -->
        <a class="dropdown profile">
            <img [routerLink]="''" (click)="lanchService('')" src="assets/logos/icon_enovsky.png">
            <div class="dropdown-content">
                <li>
                <p style="margin: 0; font-size: medium;">{{userInfos? userInfos['first_name']:''}}</p>
                <p style="margin: 0; ">{{userInfos? userInfos['email']: ''}}</p>
                </li> 
                <li *ngIf="userInfos['connected'] == true" style="font-weight: bold; text-align: center;" (click)="signOut()">Sign out</li>
                <li *ngIf="userInfos['connected'] == false" [routerLink]="'connect'" (click)="lanchService('connect')" style="font-weight: bold; text-align: center;">Connect</li>
                <div style="text-align: center; color: black">v2.3.1</div>
            </div>
        </a>
        
        </mat-toolbar>
        <h2>{{service['name']}}</h2>
        <mat-progress-bar *ngIf="inProgress" class="progress_bar" mode="buffer"></mat-progress-bar>

        <div *ngIf="['', 'connect'].includes(service['key'])" class="download-container">
            <div class="download-card">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88"><path fill="#0078D4" d="M0 12.54L35.76 7v35.23H0V12.54zM39.69 6.4L88 0v42.21H39.69V6.4zM0 45.79h35.76V81L0 75.54V45.79zm39.69-.14H88V88l-48.31-6.82V45.65z"/></svg>
                <h3>Windows</h3>
                <p>Téléchargez et installez le format .exe sur Windows 10 / 11</p>
                <a [routerLink]="'build-pdf'" (click)="lanchService('build-pdf')">Build PDF</a>
            </div>

            <div class="download-card">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17"><path fill="#000" d="M13.99 13.16c-.36.81-.53 1.16-1 1.88-.65 1.02-1.57 2.29-2.71 2.31-1.01.02-1.27-.66-2.64-.66-1.38 0-1.66.64-2.65.68-1.07.04-1.89-1.11-2.54-2.12-1.73-2.64-1.91-5.75-.85-7.41.76-1.19 2.11-1.88 3.34-1.88 1.25 0 2.04.64 3.07.64 1 0 1.6-.64 3.07-.64 1.1 0 2.26.6 3 1.64-2.64 1.45-2.21 5.27.92 6.56zM9.5 0c.2 1.47-.71 3.01-1.6 3.97-.9.95-2.34 1.68-3.58 1.59C4.1 4.1 4.85 2.48 5.7 1.55 6.55.63 8.07-.18 9.5 0z"/></svg>
                <h3>macOS</h3>
                <p>Téléchargez et installez le format .dmg sur MacOS (à partir de Monterey)</p>
                <a [routerLink]="'edit-pdf'" (click)="lanchService('edit-pdf')">Edit PDF</a>
            </div>

            <div class="download-card">
                <!-- Icône globe pour "En ligne" -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64">
                    <circle cx="32" cy="32" r="32" fill="#4CAF50"/>
                    <path fill="#fff" d="M32 12a20 20 0 100 40 20 20 0 000-40zm0 2c2.7 0 5.2.7 7.4 1.9-1.3 1.7-2.5 4.1-3.4 7.1H28c-.9-3-2.1-5.4-3.4-7.1A18.02 18.02 0 0132 14zm-8.6 3.4c1.6 2 2.9 4.9 3.7 8.6H17.2a18.03 18.03 0 016.2-8.6zM14 32c0-2.1.3-4.1.9-6h11.2c.2 2 .4 4 .4 6s-.2 4-.4 6H14.9c-.6-1.9-.9-3.9-.9-6zm3.2 10h9.9c-.8 3.7-2.1 6.6-3.7 8.6a18.03 18.03 0 01-6.2-8.6zM32 50a18.02 18.02 0 01-7.4-1.9c1.3-1.7 2.5-4.1 3.4-7.1h8c.9 3 2.1 5.4 3.4 7.1A18.02 18.02 0 0132 50zm8.6-3.4c-1.6-2-2.9-4.9-3.7-8.6h9.9a18.03 18.03 0 01-6.2 8.6zM37.6 38c-.2-2-.4-4-.4-6s.2-4 .4-6h11.2c.6 1.9.9 3.9.9 6s-.3 4.1-.9 6H37.6zm-1.4-14c.8-3.7 2.1-6.6 3.7-8.6a18.03 18.03 0 016.2 8.6H36.2z"/>
                </svg>
                <h3>En ligne</h3>
                <p>Accédez à Virtual School directement depuis votre navigateur</p>
                <a [routerLink]="'pdf-to-docx'" (click)="lanchService('pdf-to-docx')">PDF to Docx</a>
            </div>

            <div class="download-card">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17"><path fill="#000" d="M13.99 13.16c-.36.81-.53 1.16-1 1.88-.65 1.02-1.57 2.29-2.71 2.31-1.01.02-1.27-.66-2.64-.66-1.38 0-1.66.64-2.65.68-1.07.04-1.89-1.11-2.54-2.12-1.73-2.64-1.91-5.75-.85-7.41.76-1.19 2.11-1.88 3.34-1.88 1.25 0 2.04.64 3.07.64 1 0 1.6-.64 3.07-.64 1.1 0 2.26.6 3 1.64-2.64 1.45-2.21 5.27.92 6.56zM9.5 0c.2 1.47-.71 3.01-1.6 3.97-.9.95-2.34 1.68-3.58 1.59C4.1 4.1 4.85 2.48 5.7 1.55 6.55.63 8.07-.18 9.5 0z"/></svg>
                <h3>macOS</h3>
                <p>Téléchargez et installez le format .dmg sur MacOS (à partir de Monterey)</p>
                <a [routerLink]="'docx-to-pdf'" (click)="lanchService('docx-to-pdf')">Docx to PDF</a>
            </div>
        </div>
        
        <div *ngIf="!['', 'connect'].includes(service['key'])">
            <app-upload-content #appUploadContent [platformInfos]="platformInfos" [userInfos]="userInfos" [filterData]="filterData" [acceptedExtention]="service['extention']" (uploadEvent)="loadUploadData($event)"></app-upload-content>

            <div fxLayout="row" fxLayout.xs="column">
                <div class="class-mat-field" fxFlex="60">
                    
                </div>
                <div *ngIf="service['key'] == 'build-pdf' && userInfos['connected'] == true" class="class-mat-field" fxFlex="20"  fxLayoutAlign="center center">
                    <button class="button-secondary-small" (click) = "loadUploadData({})">Load Previous</button>
                </div>
            </div>
        </div>
</mat-sidenav-content>



</mat-sidenav-container>

